import React from "react";
import Login from "./Login";
import Login1 from "./Login1";
import Login2 from "./Login2";

const LoginWrapper = () => {
    const currentDomain = window.location.hostname;
    console.log("currentDomain", currentDomain);
    sessionStorage.setItem("currentDomain", currentDomain);
    const domain1 = process.env.REACT_APP_DOMAIN_1;
    const domain2 = process.env.REACT_APP_DOMAIN_2;

    const isDomain1 = domain1 && currentDomain === domain1;
    const isDomain2 = domain2 && currentDomain === domain2;

    if (isDomain1) {
        return <Login2 />;
    } else if (isDomain2) {
        return <Login1 />;
    } else {
        return <Login2 />;
    }
};

export default LoginWrapper;
